import { refreshServerConfig } from 'lib/auth';

import type { Action } from 'redux';
import type { AppDispatch } from 'types';

/**
 * Clear the authenticated user and refresh serverConfig back to guest shape.
 * Needed after logout.
 */
const clearAuthenticatedSession = async (dispatch: AppDispatch) => {
  dispatch({ type: 'setUser', user: null } as Action<'setUser'>);
  await refreshServerConfig(dispatch);
};

export default clearAuthenticatedSession;
